(function() {
  var Service, Sidebar,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  Sidebar = App.loadClass('core::Angular/ReportFilters/Sidebar');


  /*
  To use inject FilterService into filter/sidebar controller
  and assign it to @scope.service. Then set beforeApply,
  defintions (via setDefinitions()) and filter_url.
  Pass the same service into you report controller
  then $watch for the filters to be changed.
   */

  exports.FilterService = (function(superClass) {
    extend(FilterService, superClass);

    function FilterService(http) {
      this.http = http;
      this.clearFilters = bind(this.clearFilters, this);
      this.searchFilters = bind(this.searchFilters, this);
      this.applyFilters = bind(this.applyFilters, this);
      this.fetchFilters = bind(this.fetchFilters, this);
      this.setDefinitions = bind(this.setDefinitions, this);
      this.sidebar = null;
      this.beforeApply = null;
      this.current_filters = null;
      this.filter_url = null;
      this.fetching_filters = false;
    }

    FilterService.prototype.setDefinitions = function(definitions) {
      this.sidebar = new Sidebar(definitions);
      this.applyFilters();
      return this.fetchFilters();
    };

    FilterService.prototype.fetchFilters = function(url, cb, turnOffFetching, search) {
      var json, json_ready;
      if (url == null) {
        url = null;
      }
      if (cb == null) {
        cb = null;
      }
      if (turnOffFetching == null) {
        turnOffFetching = true;
      }
      if (search == null) {
        search = {};
      }
      if (url == null) {
        url = this.filter_url;
      }
      this.filter_url = url;
      json_ready = this.sidebar.jsonize(true);
      json_ready.search = search;
      json = angular.toJson(json_ready);
      if (turnOffFetching) {
        this.fetching_filters = true;
      }
      return this.http.post(url, {
        query: json
      }).then((function(_this) {
        return function(response) {
          var jsr;
          jsr = response.data;
          _this.sidebar.populateSidebar(jsr.data, cb);
          if (turnOffFetching) {
            return _this.fetching_filters = false;
          }
        };
      })(this));
    };

    FilterService.prototype.applyFilters = function() {
      var doApply, ref;
      doApply = (ref = typeof this.beforeApply === "function" ? this.beforeApply() : void 0) != null ? ref : true;
      if (doApply) {
        return this.current_filters = this.sidebar.jsonize(true).filters;
      }
    };

    FilterService.prototype.searchFilters = function(filter, text) {
      var obj, search;
      if (this.fetching_filters === false) {
        search = (
          obj = {},
          obj["" + filter.name] = text,
          obj
        );
        return this.fetchFilters(null, null, false, search);
      }
    };

    FilterService.prototype.clearFilters = function() {
      this.sidebar.clearFilters();
      return this.fetchFilters();
    };

    return FilterService;

  })(Service);

}).call(this);
